"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _ActivitySelectionPopup = _interopRequireDefault(require("./ActivitySelectionPopup.vue"));
var _activeBinding = require("@/api/activeBinding");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SetupModulePopup',
  components: {
    ActivitySelectionPopup: _ActivitySelectionPopup.default
  },
  data: function data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '长期有效',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      showPopup: false,
      timeArray: [],
      // 时间展示
      ruleForm: {
        modelId: null,
        region: null,
        // 区域（首页...）
        locationCode: '',
        // 位置编码（热门，购物...(1-5)）
        category: '',
        // 所属分类(金刚区)
        locationName: '',
        // 位置编码（热门...名字）
        pic: '',
        // 主图
        tagFlag: 0,
        // 是否有标签
        tag: '',
        // 标签
        name: '',
        // 名称
        sort: '',
        // 排序
        enable: 1,
        // 是否启用
        startTime: '',
        // 启用开始时间
        endTime: '',
        // 启用结束时间
        activityType: null,
        // 活动类型1、自定义活动 2、官方活动 3、聚合页 4、通用h5
        // 活动数据
        activityName: '',
        // 活动名称
        activityId: '',
        // 活动id
        interPageFlag: 1,
        // 是否启用中转页面 0,1
        id: null,
        // 活动id
        jumpType: 3,
        jumpContent: '',
        openUrl: ''
      },
      presentationData: {
        Display_type: null,
        // 判断展示方式
        unionCode: null,
        activityType: null,
        activityImg: null,
        isActivityShow: false
      },
      rules: {
        pic: [{
          required: true,
          message: '请上传图片',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '请上传图片',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }, {
          min: 0,
          max: 500,
          message: '长度在 1 到 500 个字符',
          trigger: 'blur'
        }],
        sort: [{
          type: 'number',
          required: true,
          message: '请输入排序'
        }],
        enable: [{
          required: true,
          message: '请选择上下线',
          trigger: 'change'
        }],
        jumpContent: [{
          required: true,
          message: '请输入URL',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '请输入URL',
          trigger: 'blur'
        }]
      },
      addEndEditor: null,
      isRevealTag: false,
      // 区分图片尺寸
      titleName: '',
      iconSizeDescription: {
        '首页顶部轮播图': '图片尺寸:750*270',
        '首页顶部小轮播图': '图片尺寸:750*180',
        '首页金刚区': '图片尺寸:128*128',
        '首页5连块': '图片尺寸:248*248',
        '中部轮播图': '图片尺寸:750*180',
        '首页中部4连块': '图片尺寸:320*408',
        '首页左侧轮播': '图片尺寸:532*723',
        '首页右侧1大4小卡片': '图片尺寸:477*320',
        '悬浮窗': '图片尺寸:300*300',
        '个人中心中部轮播图': '图片尺寸:750*180'
      }
    };
  },
  methods: {
    handleSmallDivClick: function handleSmallDivClick() {},
    open: function open(data) {
      this.addEndEditor = data.type;
      if (Number(data.category) === 4) {
        this.isRevealTag = true;
      } else {
        this.isRevealTag = false;
      }
      this.titleName = data.titleName;
      console.log('data-----', data.id);
      if (data.type === 'add') {
        this.ruleForm.modelId = data.id;
        this.ruleForm.region = data.region;
        this.ruleForm.locationCode = data.locationCode;
        this.ruleForm.locationName = data.locationName;
        this.ruleForm.category = data.category;
      } else {
        console.log('data', data);
        this.getBannerManagerByIdApi(data.id);
      }

      /*
      接收data对象：
      type：add、editor（添加，编辑）
      name：名称
        id: null,
        region: null, // 区域（首页...）
        locationCode: '', // 位置编码（热门，购物...(1-5)）
        locationName: '', // 位置编码（热门...名字）
        category: '', // 所属分类(金刚区)
      */
      if (this.addEndEditor === 'add') {
        var end = new Date();
        var start = new Date();
        end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
        start.setHours(0, 0, 0, 0); // 设置为00:00:00
        end.setHours(23, 59, 59, 999); // 设置为23:59:59
        console.log(start, end);
        this.timeArray = [this.formatDate(start), this.formatDate(end)];
        console.log(this.timeArray);
      }
      this.showPopup = true;
    },
    formatDate: function formatDate(d) {
      var date = new Date(d);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + ' ' + hh + mm + ss;
    },
    onClone: function onClone() {
      this.onInit();
      this.showPopup = false;
    },
    onInit: function onInit() {
      this.ruleForm = {
        modelId: null,
        region: null,
        // 区域（首页...）
        locationCode: '',
        // 位置编码（热门，购物...(1-5)）
        category: '',
        // 所属分类(金刚区)
        locationName: '',
        // 位置编码（热门...名字）
        pic: '',
        // 主图
        tagFlag: 0,
        // 是否有标签
        tag: '',
        // 标签
        name: '',
        // 名称
        sort: '',
        // 排序
        enable: 1,
        // 是否启用
        startTime: '',
        // 启用开始时间
        endTime: '',
        // 启用结束时间
        activityType: null,
        // 活动类型1、自定义活动 2、官方活动 3、聚合页 4、通用h5
        // 活动数据
        activityName: '',
        // 活动名称
        activityId: '',
        // 活动id
        interPageFlag: 1,
        // 是否启用中转页面 0,1
        jumpType: 3,
        jumpContent: ''
      };
      this.presentationData = {
        Display_type: null,
        // 判断展示方式
        unionCode: null,
        activityType: null,
        activityImg: null,
        isActivityShow: false
      };
      this.timeArray = [];
    },
    onGetActivePictures: function onGetActivePictures() {
      if (this.presentationData.activityImg) {
        this.ruleForm.pic = this.presentationData.activityImg;
      } else {
        this.$message({
          type: 'warning',
          message: '请先去选择含有中转页的活动!'
        });
      }
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      // if (!this.ruleForm.activityId) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请先选择活动!'
      //   })
      //   return
      // }
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.addEndEditor === 'add') {
            _this.bindingBannerApi();
          } else {
            _this.updateBannerManagerApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.onInit();
    },
    handleAvatarSuccess: function handleAvatarSuccess() {},
    // 主图
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.ruleForm.pic = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    // 标签
    handleFileUploadTag: function () {
      var _handleFileUploadTag = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(_ref2) {
        var file, pictureUrl, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              file = _ref2.file;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context2.v;
              this.ruleForm.tag = pictureUrl;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.log('error ->', _t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleFileUploadTag(_x2) {
        return _handleFileUploadTag.apply(this, arguments);
      }
      return handleFileUploadTag;
    }(),
    onJumpTypeToggle: function onJumpTypeToggle(value) {
      var formName = 'ruleForm';
      this.$refs[formName].clearValidate('jumpContent');
      if (value === 2) {
        this.ruleForm.activityId = null;
        this.ruleForm.activityName = '';
        this.ruleForm.activityType = '';
        this.ruleForm.interPageFlag = 0;
        this.presentationData = {
          Display_type: null,
          unionCode: null,
          activityType: null,
          activityImg: null,
          isActivityShow: false
        };
      } else if (value === 3) {
        this.jumpContent = '';
      }
    },
    // 选择活动
    onOfficialEvent: function onOfficialEvent() {
      this.$refs.activitySelectionPopup.open();
    },
    // 绑定banner
    bindingBannerApi: function () {
      var _bindingBannerApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              if (this.ruleForm.jumpType === 2) {
                this.ruleForm.openUrl = this.ruleForm.jumpContent;
              }
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              if (this.timeArray && this.timeArray[0]) {
                params.startTime = this.timeArray[0];
                params.endTime = this.timeArray[1];
              } else {
                params.startTime = '';
                params.endTime = '';
              }
              _context3.n = 1;
              return (0, _activeBinding.bindingBannerApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '绑定成功'
                });
                this.onClone();
                this.$emit('RefreshList');
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function bindingBannerApi() {
        return _bindingBannerApi2.apply(this, arguments);
      }
      return bindingBannerApi;
    }(),
    // 查询
    getBannerManagerByIdApi: function () {
      var _getBannerManagerByIdApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(id) {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                id: id
              };
              _context4.n = 1;
              return (0, _activeBinding.getBannerManagerByIdApi)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.ruleForm.modelId = res.data.modelId;
                this.ruleForm.region = res.data.region;
                this.ruleForm.locationCode = res.data.locationCode;
                this.ruleForm.category = res.data.category;
                if (Number(res.data.category) === 4) {
                  this.isRevealTag = true;
                }
                this.ruleForm.openUrl = res.data.openUrl ? res.data.openUrl : '';
                this.ruleForm.jumpType = Number(res.data.jumpType);
                this.ruleForm.jumpContent = res.data.jumpContent;
                this.ruleForm.locationName = res.data.locationName;
                this.ruleForm.pic = res.data.pic;
                this.ruleForm.tagFlag = res.data.tagFlag;
                this.ruleForm.tag = res.data.tag;
                this.ruleForm.name = res.data.name;
                this.ruleForm.sort = res.data.sort;
                this.ruleForm.enable = res.data.enable;
                this.ruleForm.startTime = res.data.startTime;
                this.ruleForm.endTime = res.data.endTime;
                this.ruleForm.activityType = res.data.activityType;
                this.ruleForm.activityName = res.data.activityName;
                this.ruleForm.activityId = res.data.activityId;
                this.ruleForm.interPageFlag = res.data.interPageFlag;
                this.ruleForm.id = res.data.id;
                if (res.data.startTime) {
                  this.timeArray = [res.data.startTime, res.data.endTime];
                }
                this.presentationData.isActivityShow = true;
                this.presentationData.Display_type = Number(res.data.activityType);
                if (Number(res.data.activityType) === 1) {
                  this.presentationData.activityType = '自定义活动';
                } else if (Number(res.data.activityType) === 2) {
                  this.presentationData.activityType = '官方活动';
                } else if (Number(res.data.activityType) === 3) {
                  this.presentationData.activityType = '聚合页';
                } else if (Number(res.data.activityType) === 4) {
                  this.presentationData.activityType = '通用H5';
                } else if (Number(res.data.activityType) === 5) {
                  this.presentationData.activityType = '自定义页面';
                } else if (Number(res.data.activityType) === 6) {
                  this.presentationData.activityType = '商品列表活动';
                } else if (Number(res.data.activityType) === 7) {
                  this.presentationData.activityType = '第三方代下单活动';
                } else if (Number(res.data.activityType) === 8) {
                  this.presentationData.activityType = '礼金补贴活动';
                } else if (Number(res.data.activityType) === 9) {
                  /**
                  * （流程）二：名字修改
                  */
                  this.presentationData.activityType = '超级补贴活动';
                }
                if (Number(res.data.activityType) === 1 || Number(res.data.activityType) === 2) {
                  this.presentationData.unionCode = res.data.activityDetail.unionCode;
                  this.presentationData.activityImg = res.data.activityDetail.mainImage;
                }
                if (Number(res.data.activityType) === 6) {
                  this.presentationData.unionCode = res.data.customActivityDetail.platformCode;
                  this.presentationData.activityImg = res.data.customActivityDetail.picUrl;
                }
                if (Number(res.data.activityType) === 7) {
                  this.presentationData.activityImg = res.data.thirdPartyActivityDetail.mainImage;
                }
                if (Number(res.data.activityType) === 3) {
                  this.presentationData.activityImg = res.data.aggregatePageDetail.pic;
                }
                if (Number(res.data.activityType) === 8) {
                  this.presentationData.activityImg = res.data.freePurchaseActivityDTO.headerPic;
                }
                if (Number(res.data.activityType) === 9) {
                  console.log('res.data', res.data);
                  /**
                  * （流程）三：图片修改(回查)
                  */
                  this.presentationData.activityImg = res.data.buyRestitutionActivityDTO.mainPic;
                }
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function getBannerManagerByIdApi(_x3) {
        return _getBannerManagerByIdApi2.apply(this, arguments);
      }
      return getBannerManagerByIdApi;
    }(),
    updateBannerManagerApi: function () {
      var _updateBannerManagerApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              if (this.ruleForm.jumpType === 2) {
                this.ruleForm.openUrl = this.ruleForm.jumpContent;
              }
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              if (this.timeArray && this.timeArray[0]) {
                params.startTime = this.timeArray[0];
                params.endTime = this.timeArray[1];
              } else {
                params.startTime = '';
                params.endTime = '';
              }
              _context5.n = 1;
              return (0, _activeBinding.updateBannerManagerApi)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
                this.onClone();
                this.$emit('RefreshList');
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.log(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function updateBannerManagerApi() {
        return _updateBannerManagerApi2.apply(this, arguments);
      }
      return updateBannerManagerApi;
    }(),
    // 自定义货多功能回传
    onSelectEvents: function onSelectEvents(data) {
      console.log('data', data);
      this.presentationData.isActivityShow = true;
      this.presentationData.activityType = data.Display_name;
      this.presentationData.Display_type = data.Display_type;
      this.ruleForm.activityType = data.Display_type;
      this.ruleForm.openUrl = data.openUrl ? data.openUrl : '';
      if (data.Display_type === 1 || data.Display_type === 2) {
        // 自定义活动，官方活动 回填
        // 本地展示
        this.presentationData.unionCode = data.unionCode;
        this.presentationData.activityImg = data.mainImage;
        // 参数
        this.ruleForm.activityName = data.name;
        this.ruleForm.activityId = data.id;
        this.ruleForm.interPageFlag = 1;
      } else if (data.Display_type === 3) {
        // 聚合页活动回填
        this.ruleForm.activityName = data.name;
        this.ruleForm.activityId = data.id;
        this.presentationData.activityImg = data.activityList[0].activityPic;
      } else if (data.Display_type === 4) {
        // 通用H5活动 回填
        this.ruleForm.activityName = data.name;
        this.ruleForm.activityId = data.pageId;
      } else if (data.Display_type === 5) {
        this.ruleForm.activityName = data.title;
        this.ruleForm.activityId = data.id;
      } else if (data.Display_type === 6) {
        // 自定义活动，官方活动 回填
        // 本地展示
        this.presentationData.unionCode = data.platformCode;
        this.presentationData.activityImg = data.picUrl;
        // 参数
        this.ruleForm.activityName = data.activityName;
        this.ruleForm.activityId = data.id;
      } else if (data.Display_type === 7) {
        // 第三方 代下单  回填
        this.presentationData.activityImg = data.mainImage;
        // 参数
        this.ruleForm.activityName = data.name;
        this.ruleForm.activityId = data.id;
      } else if (data.Display_type === 8) {
        this.ruleForm.activityName = data.activityName;
        this.ruleForm.activityId = data.id;
        this.presentationData.unionCode = data.platformCode;
        this.presentationData.activityImg = data.headerPic;
      } else if (data.Display_type === 9) {
        /**
         * （流程）一.接受详情回传参数进行复制
         */
        this.ruleForm.activityName = data.activityName;
        this.ruleForm.activityId = data.id;
        this.presentationData.unionCode = data.platformCode;
        this.presentationData.activityImg = data.mainPic;
      }
    }
  }
};